/** @jsx jsx */
import { jsx } from 'theme-ui';
import styled from '@emotion/styled';
import FooterLogo from '../logo/footerAltLogo';
import theme_v1 from '../../gatsby-plugin-theme-ui-v1';
import theme_v2 from '../../gatsby-plugin-theme-ui';

function generateBrandSpecificComponents (brand, region) {
  var theme;
  if(region === 'US') {
    theme = theme_v2;
  } else {
    theme = theme_v1;
  }

  const brandColors = theme.referenceColors;

  const Container = styled.footer`
    background-color: ${brandColors.heading};    
    font-size: 11px;
    padding: 1em;
    text-align: center;
    width: 100%;
    height: ${theme.sizes.footerHeight};
    color: #fff;

    .left {
      float:left;
      padding-left: 20px;
    }
    .right {
      float: right;
      padding-right: 20px;
    }

    @media only screen and (max-width: 500px) {
      .left {
        float: inherit;
        padding: 5px 0;
        }
      .right {
        float: inherit;
        padding: 5px 0px;

        a:nth-child(3) {
          display: block;
          padding: 8px 0;
        }
      }
    }

    && {
      a {
        font-weight: 500;
        font-size: 11px;
        font-style: normal;
        text-decoration: none;
        letting-spacing: 0.5px;
        padding-right: 15px;
        color: rgba(255,255,255);
        &:hover {
          text-decoration: none;
        }
      }

    }
  `;
  return Container
}

const Footer = ({ regionConfig }) => {
  var Container = generateBrandSpecificComponents (regionConfig.brand, regionConfig.region)

  return (
    <Container>
      <div class="left">{regionConfig.copyrightText}</div>
      <div class="right">
        {regionConfig.footerLinks
          .map((link) => {
            return (
              <a key={link.url} href={`${link.url}`}>
                {link.title}
              </a>
            );
          })
          .reduce((prev, curr) => [prev, ' ', curr])}
      </div>
    </Container>
  );  
};

export default Footer;
